<template>
	<el-tooltip :content="props.data" placement="top" :disabled="!isOverflow" popper-class="haveElpopperarrow">
		<div :class="props.class || 'ellipsisSty'" :ref="props.dataRef"
			@mouseover="checkOverflow(props.dataRef, props.no)" @mouseleave="isOverflow = false">
			{{props.data}}
		</div>
	</el-tooltip>
</template>

<script setup>
	const {
		proxy
	} = getCurrentInstance()
	const props = defineProps({
		data: {
			type: String,
			default: null
		},
		dataRef: {
			type: String,
			default: null
		},
		class: {
			type: String,
			default: ''
		},
		no: {
			type: Boolean,
			default: false
		}
	})
	const isOverflow = ref(false) // 文本溢出部分显示

	// 文本溢出部分显示
	function checkOverflow(textContainer, no) {
		let el = proxy.$refs[textContainer]
		console.log(textContainer, el, el.scrollWidth, el.clientWidth, el.scrollHeight, el.clientHeight, 'checkOverflow')
		// isOverflow.value = el.scrollWidth > el.clientWidth || (no ? false : el.scrollHeight > el.clientHeight)
		isOverflow.value = el.scrollWidth > el.clientWidth || (no ? false : el.scrollWidth > el.clientWidth)
	}
</script>

<style lang="scss" scoped>
	@import "@/styles/handle.scss";

	.detailsBloStyM {
		width: 100%;
		max-width: 188px;
		height: 30px;
		padding: 0 12px;
		border-radius: 2px;
		font-size: 12px;
		line-height: 30px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		box-sizing: border-box;
		@include color('color_FFF');
	}

	@media screen and (max-width: 1880px) {

		// .detailsBloStyM {
		// 	width: 9vw !important;
		// }
	}

	@media screen and (max-width: 1730px) {

		// .detailsBloStyM {
		// 	width: 8vw !important;
		// }
	}

	@media screen and (max-width: 1594px) {

		// .detailsBloStyM {
		// 	width: 7vw !important;
		// }
	}

	@media screen and (max-width: 1480px) {

		// .detailsBloStyM {
		// 	width: 6.65vw !important;
		// }
	}

	@media screen and (max-width: 1440px) {

		.detailsBloStyM {
			// width: 8.4vw !important;
		}
	}

	@media screen and (max-width: 1300px) {

		// .detailsBloStyM {
		// 	width: 7.15vw !important;
		// }
	}

	@media screen and (max-width: 1200px) {

		// .detailsBloStyM {
		// 	width: 8.8vw !important;
		// }
	}

	@media screen and (max-width: 1132px) {

		// .detailsBloStyM {
		// 	width: 7.8vw !important;
		// }
	}

	@media screen and (max-width: 1072px) {

		// .detailsBloStyM {
		// 	width: 7vw !important;
		// }
	}

	.detailsBloStyG {
		width: 236px; // 240 => 236
		height: 36px;
		line-height: 36px;
		padding: 0 16px;
		border-radius: 2px;
		box-sizing: border-box;
		font-size: 14px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		@include color('color_FFF');
		@include background('select_back');
	}

	.detailsBloStyG.widthPercentage {
		width: calc(100% - 16px);
		white-space: nowrap;
		overflow: hidden;
	}
</style>